// ArrowControl.js
import { elementTools, dia } from '@joint/plus'

export class ArrowOffsetControl extends elementTools.Control {

    protected override getPosition(view: dia.ElementView): dia.Point {
        const model = view.model;
        const pos = model.position();
        const attrs = model.get('attrs') || {};
        if (attrs['control']) {
            let { arrowHeight, thickness } = attrs['control'];
            const { width, height } = model.size();
            return { x: width - arrowHeight, y: height / 2 - thickness / 2 };
        }
        return {
            x: pos.x,
            y: pos.y 
        };
    }

    protected override setPosition(view: dia.ElementView, coordinates: dia.Point): void {
        const model = view.model;
        const { x, y } = coordinates;
        const attrs = model.get('attrs') || {};
        if (attrs['control']) {
            const { width, height } = model.size();
            const arrowHeight = Math.max(0, Math.min(width - coordinates.x, width));
            attrs['control']['arrowHeight'] = arrowHeight;
            const thickness = Math.max(
                0,
                Math.min(height - 2 * coordinates.y, height)
            );
            attrs['control']['thickness'] = thickness;
            model.attr('body/d', `M calc(w-${arrowHeight}) 0
                    L calc(w) calc(0.5*h)
                    L calc(w -${arrowHeight})  calc(h)
                    v -calc(h/2 - ${thickness / 2})
                    H 0
                    v -${thickness}
                    H calc(w- ${arrowHeight})
                    z`)
        }
       
    }
}